import { jsx as _jsx } from "react/jsx-runtime";
import { BoxPrimitive } from '#pplx/frontend/aether/primitives/BoxPrimitive/index.js';
import { IconPrimitive } from '#pplx/frontend/aether/primitives/IconPrimitive/index.js';
import { IncognitoType } from '#pplx/frontend/apps/ask/incognito/types.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import classNames from 'classnames';
import React from 'react';
export const IncognitoIcon = React.memo(function IncognitoIcon({ size, inverse, incognitoType = IncognitoType.DEFAULT, }) {
    return (_jsx(BoxPrimitive, { display: "flex", align: "center", justify: "center", bg: "background", className: classNames('w-8 text-primary aspect-square shrink-0 rounded-full border', { '!w-6': size === 'small', '!w-4': size === 'tiny' }, {
            '!bg-inverse !text-inverse border-0': inverse,
        }), children: _jsx(IconPrimitive, { icon: incognitoType === IncognitoType.GOVERNMENT
                ? $icon('custom-perplexity-government')
                : $icon('spy'), size: size === 'tiny' ? 11 : size === 'small' ? 12 : 18 }) }));
});
//# sourceMappingURL=IncognitoIcon.js.map